import { useTranslation } from "react-i18next"

const FEATURES = [
  {
    emoji: "💬",
    titleKey: "components.whatsAppHighlight.features.trackViaChatTitle",
    descKey: "components.whatsAppHighlight.features.trackViaChatDesc",
  },
  {
    emoji: "⏰",
    titleKey: "components.whatsAppHighlight.features.smartRemindersTitle",
    descKey: "components.whatsAppHighlight.features.smartRemindersDesc",
  },
  {
    emoji: "📊",
    titleKey: "components.whatsAppHighlight.features.dailySummaryTitle",
    descKey: "components.whatsAppHighlight.features.dailySummaryDesc",
  },
] as const

export default function WhatsAppHighlight() {
  const { t } = useTranslation()

  return (
    <div>
      <div className="mb-6 flex items-center justify-center gap-2">
        <span className="text-2xl">📱</span>
        <h2 className="text-custom-charcoal text-center text-xl font-extrabold">
          {t("components.whatsAppHighlight.heading")}
        </h2>
      </div>

      <div className="space-y-3">
        {FEATURES.map((feature) => (
          <div
            key={feature.titleKey}
            className="flex items-start gap-4 rounded-2xl bg-white px-5 py-4"
          >
            <span className="mt-0.5 text-2xl">{feature.emoji}</span>
            <div>
              <p className="text-custom-charcoal text-sm font-bold">
                {t(feature.titleKey)}
              </p>
              <p className="mt-0.5 text-sm text-gray-500">
                {t(feature.descKey)}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-custom-teal-light mt-4 rounded-2xl px-5 py-4 text-center">
        <p className="text-custom-teal-dark text-sm font-semibold">
          {t("components.whatsAppHighlight.stat")}
        </p>
      </div>
    </div>
  )
}
